import { render, staticRenderFns } from "./ManageMenu.vue?vue&type=template&id=25efd392&scoped=true"
import script from "./ManageMenu.vue?vue&type=script&lang=js"
export * from "./ManageMenu.vue?vue&type=script&lang=js"
import style0 from "./ManageMenu.vue?vue&type=style&index=0&id=25efd392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25efd392",
  null
  
)

export default component.exports